<template>
  <BaseSegment :title="label" :desc="config.desc" :icon="config.icon" style="width:100%">
        <div slot="title" class="flex-wrap">
          {{label}}
          <span v-if="config.inputBatch" style="color:red;margin-left:5px;background:#ff333333;border-radius:5px;padding:2px 8px;font-size:12px;"> 批量录入</span>
          <div class="flex-wrap" style="margin-left:10px">
            <div v-if="config.needAttachment"  class="flex-wrap flex-center" style="width:30px;height:30px;background:var(--border);border-radius:5px;margin-left:5px">
              <BaseIcon icon="photo" style="" :size="25" title="此栏目建议上传图片附件"/>
            </div>

              <div v-if="config.samplePicture && config.samplePicture.length > 0" class="flex-wrap flex-center" @click="showSample=true" style="cursor:pointer;width:30px;height:30px;background:var(--border);border-radius:5px;margin-left:5px">
                <BaseIcon icon="images" :size="23" />

              </div>
              <Modal v-model="showSample" footer-hide :width="600"  title="示例图片">
                  <BaseImageUpload :value="config.samplePicture" disabled :option="{size:150}" />
              </Modal>


            </div>
        </div>
        <draggable
          tag="div"
          v-model="localList"
          group="control"
          :animation="500"
          @input="emitChange"
          :disabled="!design"
          filter=".drag-tip"
          style="background:#ffffffee;min-height:150px;width:100%;display: block;border:1px dashed #aaa;position:relative;"
          :style="`${design?'':'border:none;'}`"
        >
        <template v-if="design">
          <div class="flex-wrap flex-center" style="height:150px;width:100%;color:var(--subtext2)" v-if="localList.length == 0">
            拖拽组件至此处
          </div>
          <template v-else>

            <template v-for="(c,i) in localList">
              <div class="form-item flex-col flex-between" :class="{
                'form-item-selected':selected && selected.id == c.id,
                'form-item-mandatory':c?.config?.mandatory
              }"   :key="c.id"
              @click.stop="handleClick(c)" style="border:1px solid var(--primary);margin:12px;position:relative;overflow:hidden;padding:5px;">
              <div class="l-mask" v-if="!isContainer(c.control) && design"></div>
              <div class="l-remove-btn" @click.stop="handleRemove(i)"><Icon type="md-close" /></div>
              <div class="l-remove-btn" style="right:20px;" @click.stop="handleCopy(c)"><Icon type="md-copy" /></div>
                <component
                :is="c.control"
                :required="c.required?true:false"
                :selected="selected"
                :label="`${c.name}${c?.config?.mandatory?' [强制性条款]':''}${c?.config?.important?' [重要条款]':''}${c?.config?.needAttachment?' [建议上传附件]':''}${Array.isArray(c?.config?.samplePicture) && c.config.samplePicture.length > 0?' [图片示例] ':''}`"
                :id="c.id"
                :fields="c.fields"
                :fkey="c.key"
                :config="c.config"
                :editable="editable"
                :value="c?.config?.defaultValue"
                :design="design"
                @select="$emit('select', $event)"
                @change="$set(c,'fields',$event);emitChange()"
                />
                <div v-if="c?.config?.attachment" style="margin-left:15px;width:calc(100% - 15px);color:var(--subtext2)">
                附件:请上传{{c?.config?.attachment=='image'?'照片':'照片或文件'}}
                <UgoFile />
              </div>
              </div>

              </div>

            </template>
              </template>
            </div>
          </template>
          <template v-else>
            <template v-for="c in fields">
              <div class="form-item flex-wrap flex-between" :class="{
                 'form-item-mandatory':c?.config?.mandatory
              }" :key="c.id"
              @click.stop="handleClick(c)"
               v-if="acl[c.fullkey]!=2"
              style="position:relative;overflow:hidden;padding:5px;">
                <component
                  :is="c.control"
                  :ref="c.key"
                  :label="`${c.name}${c?.config?.mandatory?'[强制性条款] ':''}${Array.isArray(c?.config?.samplePicture) && c.config.samplePicture.length > 0?'[图片示例] ':''}`"
                  :required="c.required?true:false"
                  :fkey="c.key"
                  :fields="c.fields"
                  :acl="acl"
                  :id="c.id"
                  :p_many="p_many"
                  :p_one="p_one"


                  :model="model"
                  :config="c.config"
                  :editable="editable && (!c.config || !c.config.disabled) && !acl[c.fullkey]"
                  :value="isContainer(c.control)?value:value[c.key]"
                   :old="isContainer(c.control)?old:(old?old[c.key]:undefined)"
                   @input="handleEmitInput(c,$event)"
                />


              </div>
              <div v-if="c?.config?.attachment" style="margin-left:15px;color:var(--subtext2)">
                附件:请上传{{c?.config?.attachment=='image'?'照片':'照片或文件'}}
                <UgoFile />
              </div>


            </template>

          </template>
          <div v-if="fields.length > 0 && design" style="padding:5px;text-align:center;color:var(--subtext2)">拖拽组件至此处</div>
          </draggable>
              <div v-if="config.attachment" style="margin-top:10px;">
                <div style="margin-left:10px;color:var(--subtext2)">
               栏目附件:请上传{{config?.attachment=='image'?'照片':'照片或文件'}}  </div>
                <UgoFile />
              </div>
              <div v-if="config?.signature" style="margin-left:15px;color:var(--subtext2)">
                <template v-for="s in config.signature">

                  <UgoSignature :label="s.identify" style="margin-top:5px;" />
                </template>
              </div>
  </BaseSegment>
</template>

<script>
import draggable from 'vuedraggable';
import {cloneDeep} from 'lodash';
import composedMixin from '../mixins/composed';
let idGlobal = 1;
export default {
  cname: '栏目/分组',
  icon: 'form',
  corder: 79,
  components: {
    draggable,
  },
  mixins: [composedMixin],
  data() {
    return {
      showSample: false,
      localList: cloneDeep(this.fields) || [],
    };
  },
  watch: {
    fields: {
      handler(v) {
        this.localList = cloneDeep(v) || [];
      },
      deep: true,
    },
  },
  props: {
    design: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Object,
    },
    fields: {
      type: Array,
      default: ()=>([]),
    },
    label: {
      type: String,
    },

    model: {
      type: Object,
      default: ()=>({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
    },
    config: {
      type: Object,
      default: ()=>({}),
    },
    acl: {
      type: Object,
      default: ()=>({}),
    },

  },
  properties: [
    {
      label: '描述',
      key: 'desc',
      control: 'Text',
    },

  ],
  methods: {
    handleRemove(i) {
      this.Confirm('请注意，<span style=\'color:red\'>直接删除表单项可能会导致数据绑定失效</span>。是否继续？', ()=>{
        this.localList.splice(i, 1);
        this.emitChange();
      });
    },
    getUpdateData() {
      const updateData = {};
      this.fields.forEach((f)=>{
        if (!Array.isArray(this.$refs[f.key]) || !this.$refs[f.key][0]) {
          return;
        }
        const component = this.$refs[f.key][0];
        const getUpdate = component.getUpdateData;
        if (getUpdate) {
          const val = getUpdate();
          if (this.isContainer(f.control)) {
            if (val && Object.keys(val).length > 0) {
              Object.assign(updateData, val);
            }
          } else {
            if (val !== undefined) {
              updateData[f.key] = val;
            }
          }
        } else {
          if ((this.old[f.key] !== this.value[f.key])) {
            updateData[f.key] = this.value[f.key];
          }
        }
      });

      if (Object.keys(updateData).length > 0) {
        return updateData;
      }
    },
    handleClick(c) {
      this.$emit('select', {item: c, ctx: this});
    },
    createID() {
      const time = Date.now();
      return time.toString(16) + idGlobal++;
    },
    handleCopy(e) {
      const cloned = cloneDeep(e);
      const newId = this.createID();
      cloned.id = 'field-'+newId;
      cloned.key = 'field-'+newId;
      if (cloned.fields) {
        this.traversalFeilds(cloned.fields, (f)=>{
          newID = this.createID();
          if (f.id) {
            f.id = 'field-'+newID;
            f.key = f.key + '_'+newID;
          }
        });
      }
      const index = this.localList.findIndex((f)=>f.id == e.id);
      if (index !== -1) {
        this.localList.splice(index+1, 0, cloned);
      }
      this.emitChange();
    },
    handleEmitInput(c, e) {
      if (this.isContainer(c.control)) {
        this.$emit('input', e);
      } else {
        this.$emit('input', {key: c.key, value: e});
      }
    },
    handleEnd(e) {
      console.log('end:', e);
    },
    initCol(i) {
      return {
        key: 'inner'+i,
        fields: [],
      };
    },
    emitChange() {
      this.$emit('change', cloneDeep(this.localList));
    },
    isContainer(control) {
      return this.$store.getters['forms/containers'].includes(control);
    },
  },

  initModel(obj) {
    obj.config = {
      cols: 2,
    };
    obj.fields = [];
    return obj;
  },
};
</script>

<style lang="scss" scoped>

</style>
